const SNAPSHOT_CONTINUATION_RE = /^Continue from the saved snapshot(?: for "[^"]*(?:"|\u2026)?)?\.?\s*(?:Original task:\s*)?/i;
const SNAPSHOT_CONTEXT_MAX_CHARS = 12000;

export function unwrapSnapshotContinuationText(value?: string) {
  let text = String(value || "").trim();
  for (let depth = 0; depth < 5; depth += 1) {
    const originalTaskParts = text.split(/Original task:\s*/i);
    if (originalTaskParts.length > 1) {
      text = originalTaskParts[originalTaskParts.length - 1].trim();
      if (!text) break;
      continue;
    }
    const next = text.replace(SNAPSHOT_CONTINUATION_RE, "").trim();
    if (next === text) break;
    text = next;
    if (!text) break;
  }
  return text;
}

export function clippedSnapshotContext(value?: string, maxChars = SNAPSHOT_CONTEXT_MAX_CHARS) {
  const text = String(value || "").trim();
  if (!text || text.length <= maxChars) return text;
  return text.slice(0, maxChars).trimEnd() + "\n\n[Saved context truncated for fast continuation.]";
}

export function shouldUsePromptContextSnapshotContinuation(input: {
  contextText?: string;
  gateway?: boolean;
  persistent?: boolean;
  runtimeSessionId?: string;
}) {
  return Boolean(
    input.gateway &&
    String(input.contextText || "").trim() &&
    !input.persistent &&
    !String(input.runtimeSessionId || "").trim(),
  );
}

export function buildSnapshotContinuationPrompt(input: {
  title?: string;
  label?: string;
  sourceText?: string;
  contextText?: string;
}) {
  const sourcePrompt = unwrapSnapshotContinuationText(input.sourceText || input.title || input.label);
  const continuationTitle = unwrapSnapshotContinuationText(input.title || input.label) || sourcePrompt || "saved task";
  const contextText = clippedSnapshotContext(input.contextText);
  return [
    `Continue from the saved snapshot for "${continuationTitle}".`,
    sourcePrompt ? `Original task:\n${sourcePrompt}` : "",
    contextText ? `Saved context:\n${contextText}` : "",
  ].filter(Boolean).join("\n\n");
}
